// extracted by mini-css-extract-plugin
export default {"container":"LoadingView_container__8yGnw","dark":"LoadingView_dark__dGQnp"};